package com.patronat.top.features.auth.presentation.ui

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.features.auth.presentation.AuthEvent
import com.patronat.top.features.auth.presentation.AuthStep
import com.patronat.top.features.auth.presentation.AuthViewModel
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.molecules.branding.AppLogo
import com.patronat.top.ui.molecules.inputs.AppOtpInput
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.LabelLarge
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.stringResource
import top.features.auth.generated.resources.Res
import top.features.auth.generated.resources.*

@Composable
fun VerifyCodeContent(viewModel: AuthViewModel) {
    val state by viewModel.viewState.collectAsState()


    var codeValue by remember { mutableStateOf("") }


    LaunchedEffect(state.step) {
        codeValue = ""
    }


    var timeLeft by remember { mutableStateOf(59) }

    LaunchedEffect(state.isOtpSent) {
        if (state.isOtpSent) {
            timeLeft = 59
            while (timeLeft > 0) {
                delay(1000L)
                timeLeft--
            }
        }
    }

    val timerString = remember(timeLeft) {
        val minutes = timeLeft / 60
        val seconds = timeLeft % 60
        "${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}"
    }

    val (titleRes, subtitleRes, buttonTextRes) = when (state.step) {
        AuthStep.LoginVerify -> Triple(
            Res.string.login_title,
            Res.string.login_verify_subtitle,
            Res.string.action_login
        )
        AuthStep.RegisterVerifyPhone -> Triple(
            Res.string.reg_step_2_title,
            Res.string.reg_step_2_subtitle,
            Res.string.action_continue
        )
        AuthStep.RegisterVerifyEmail -> Triple(
            Res.string.reg_step_3_title,
            Res.string.reg_step_3_subtitle,
            Res.string.action_register
        )
        else -> Triple(Res.string.login_title, Res.string.login_verify_subtitle, Res.string.action_login)
    }

    Column(
        modifier = Modifier
            .wrapContentSize()
            .padding(bottom = 20.dp),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Center
    ) {

        AppLogo()

        Spacer(modifier = Modifier.height(24.dp))

        Text(
            text = stringResource(titleRes),
            style = LabelLarge.copy(fontSize = 24.sp),
        )

        Spacer(modifier = Modifier.height(8.dp))

        Text(
            text = stringResource(subtitleRes),
            style = BodyMedium
        )

        Spacer(modifier = Modifier.height(32.dp))

        AppOtpInput(
            value = codeValue,
            onValueChange = {
                codeValue = it
                if (state.errorMessage != null) {
                    viewModel.onEvent(AuthEvent.ClearError)
                }
            },
            length = 6,
            timerText = timerString,
            errorText = state.errorMessage?.asString(),
            onResendClick = {
                if (timeLeft == 0) {
                    viewModel.onEvent(AuthEvent.OnResendCode)
                    timeLeft = 59
                }
            }
        )

        Spacer(modifier = Modifier.height(24.dp))

        AppButton(
            text = stringResource(buttonTextRes),
            onClick = { viewModel.onEvent(AuthEvent.OnSubmitCode(codeValue)) },
            type = ButtonType.BrownFilled,
            isLoading = state.isLoading,
            enabled = codeValue.length == 6,
            modifier = Modifier.fillMaxWidth()
        )
    }
}